import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "notification";

moduleApi.create = (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.createLog = (dataForm) => {
  let api = {
    module: moduleName + "_log",
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.listLogs = (dataFilter) => {
  let api = {
    module: moduleName + '_log',
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.deleteLog = (id) => {
  let api = {
    module: moduleName + '_log',
    type: "delete",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findLogById = (id) => {
  let api = {
    module: moduleName + "_log",
    type: "findById",
    value: {id: id}
  };
  return ApiService(api);
};

export default moduleApi;
